import React from "react";
import StudiesIcon from "@mui/icons-material/LibraryBooksOutlined";
import StudyIcon from "@mui/icons-material/QueryStatsOutlined";
import AnalyticsIcon from "@mui/icons-material/InsightsOutlined";
import KitsIcon from "@mui/icons-material/ScienceOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CentersIcon from "@mui/icons-material/HomeWorkOutlined";
import SponsorsIcon from "@mui/icons-material/Apartment";
import UsersIcon from "@mui/icons-material/People";
import ProductionsIcon from "@mui/icons-material/Biotech";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlaskVial } from "@fortawesome/free-solid-svg-icons";
import SampleIcon from "@mui/icons-material/Science";

const renderTitle = (
  location,
  studyCode,
  studyId,
  centerNumber,
  centerUser,
  centerId,
  t,
  navigate,
) => {
  let title;
  const rowSx = {
    display: "flex",
    alignItems: "center",
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    lineHeight: 1,
  };
  const clickableSx = {
    cursor: "pointer",
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    lineHeight: 1,
    display: "inline-flex",
    alignItems: "center",
  };
  const separatorSx = {
    fontSize: "15px",
    lineHeight: 1,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: "12px",
    marginRight: "10px",
    alignSelf: "center",
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
  };

  const studyTarget = centerUser
    ? {
        path: "/productions",
        state: { studyId, studyCode, centerNumber, centerId },
      }
    : studyCode && studyId
      ? { path: "/centers", state: { studyId, studyCode } }
      : null;

  const centerTarget = centerNumber
    ? {
        path: "/productions",
        state: { studyId, studyCode, centerNumber, centerId },
      }
    : null;
  const orderNumber =
    location.state?.order?.orderNumber || location.state?.orderNumber;
  const orderId = location.state?.orderId || location.state?.order?.id;
  const showOrderCrumb =
    Boolean(orderNumber) &&
    ["/shipping", "/shipping/new", "/aor"].includes(location.pathname);
  const orderTarget = showOrderCrumb
    ? {
        path: "/order",
        state: {
          orderId,
          order: location.state?.order,
          studyId,
          studyCode,
          centerNumber,
          centerId,
        },
      }
    : null;

  const navigateTo = (target) => {
    if (!target || !navigate) return;
    navigate(target.path, { state: target.state });
  };

  const path = location?.pathname || "";
  const isSampleShipmentReceptionRoute =
    /^\/sample-shipments\/[^/]+\/reception$/.test(path);
  const isSampleShipmentBiobankRoute =
    /^\/sample-shipments\/[^/]+\/biobank$/.test(path);
  const isSampleShipmentDetailRoute =
    path.startsWith("/sample-shipments/") &&
    !isSampleShipmentReceptionRoute &&
    !isSampleShipmentBiobankRoute &&
    ![
      "/sample-shipments",
      "/sample-shipments/new",
      "/sample-shipments/confirm",
      "/sample-shipments/summary",
    ].includes(path);
  const isSampleFormRoute = /^\/samples\/[^/]+$/.test(path);

  // minimal, non-invasive handling for /users/:id routes
  if (path.startsWith("/users/")) {
    const userName =
      (location.state &&
        (location.state.user?.name || location.state.userName)) ||
      null;
    return (
      <div style={rowSx}>
        <UsersIcon key="icon" style={{ marginRight: "8px" }} />
        {userName || t("users")}
      </div>
    );
  }

  if (isSampleShipmentReceptionRoute) {
    title = (
      <div style={rowSx}>
        <SampleIcon style={{ marginRight: "4px" }} />{" "}
        {t("sampleShipmentReception", "Sample Shipment Reception")}
      </div>
    );
  } else if (isSampleShipmentBiobankRoute) {
    title = (
      <div style={rowSx}>
        <SampleIcon style={{ marginRight: "4px" }} />{" "}
        {t("sampleBiobanking", "Sample Biobanking")}
      </div>
    );
  } else if (isSampleShipmentDetailRoute) {
    title = (
      <div style={rowSx}>
        <SampleIcon style={{ marginRight: "4px" }} />{" "}
        {t("sampleShipmentDetail")}
      </div>
    );
  } else if (isSampleFormRoute) {
    title = (
      <div style={rowSx}>
        <SampleIcon style={{ marginRight: "4px" }} /> {t("samples")}
      </div>
    );
  }

  if (!title) {
    switch (path) {
      case "/":
        title = centerUser ? (
          <div style={rowSx}>
            <ProductionsIcon key="icon" style={{ marginRight: "4px" }} />{" "}
            {t("inventory")}
          </div>
        ) : (
          <div style={rowSx}>
            <StudiesIcon key="icon" style={{ marginRight: "8px" }} />{" "}
            {t("studies")}
          </div>
        );
        break;
      case "/legal":
        title = t("legalNotices");
        break;
      case "/centers":
        title = [
          <CentersIcon key="icon" style={{ marginRight: "4px" }} />,
          ` ${t("centers")}`,
        ];
        break;
      case "/users":
        title = (
          <div style={rowSx}>
            <UsersIcon key="icon" style={{ marginRight: "8px" }} /> {t("users")}
          </div>
        );
        break;

      case "/users/:id":
        title = (
          <div style={rowSx}>
            <UsersIcon key="icon" style={{ marginRight: "8px" }} /> {t("users")}
          </div>
        );
        break;

      case "/studies":
        title = (
          <div style={rowSx}>
            <StudiesIcon key="icon" style={{ marginRight: "8px" }} />{" "}
            {t("studies")}{" "}
          </div>
        );
        break;
      case "/study-info":
        title = (
          <div style={rowSx}>
            <SettingsIcon key="icon" style={{ marginRight: "8px" }} />{" "}
            {t("studyInfo")}{" "}
          </div>
        );
        break;
      case "/materials":
        title = [<KitsIcon key="icon" />, ` ${t("materialList")}`];
        break;
      case "/orders":
        title = (
          <div style={rowSx}>
            <ShoppingCartIcon key="icon" style={{ marginRight: "4px" }} />{" "}
            {t("orders")}
          </div>
        );
        break;
      case "/orders/":
        title = [
          <ShoppingCartIcon key="icon" style={{ marginRight: "4px" }} />,
          ` ${t("orders")}`,
        ];
        break;
      case "/orders/new":
        title = [
          <ShoppingCartIcon key="icon" style={{ marginRight: "4px" }} />,
          ` ${t("createOrder")}`,
        ];
        break;
      case "/orders/confirm":
        title = [
          <ShoppingCartIcon key="icon" style={{ marginRight: "4px" }} />,
          ` ${t("confirmOrder")}`,
        ];
        break;
      case "/shipping":
        title = [
          <LocalShippingIcon key="icon" style={{ marginRight: "4px" }} />,
          t("shippingInformation"),
        ];
        break;
      case "/shipping/new":
        title = [
          <LocalShippingIcon key="icon" style={{ marginRight: "4px" }} />,
          t("provideShippingInfo"),
        ];
        break;
      case "/shipping/confirm":
        title = [
          <LocalShippingIcon key="icon" style={{ marginRight: "4px" }} />,
          t("confirmShippingInfo"),
        ];
        break;
      case "/aor":
        title = [
          <LocalShippingIcon key="icon" style={{ marginRight: "4px" }} />,
          t("aor"),
        ];
        break;
      case "/aor-form":
        title = [
          <LocalShippingIcon key="icon" style={{ marginRight: "4px" }} />,
          t("confirmReception"),
        ];
        break;
      case "/productions":
        title = [
          <ProductionsIcon key="icon" style={{ marginRight: "4px" }} />,
          centerNumber || centerUser
            ? ` ${t("inventory")}`
            : ` ${t("productions")}`,
        ];
        break;
      case "/sponsors":
        title = (
          <div style={rowSx}>
            <SponsorsIcon key="icon" style={{ marginRight: "8px" }} />{" "}
            {t("sponsors")}
          </div>
        );
        break;
      case "/center-info":
        title = (
          <div style={rowSx}>
            <SettingsIcon key="icon" style={{ marginRight: "8px" }} />{" "}
            {t("centerInfo")}{" "}
          </div>
        );
        break;
      case "/order":
        title = [<ShoppingCartIcon key="icon" />, ` ${t("orderInfo")}`];
        break;
      case "/samples":
        title = (
          <div style={rowSx}>
            <SampleIcon style={{ marginRight: "4px" }} /> {t("samples")}
          </div>
        );
        break;
      case "/samples/new":
        title = (
          <div style={rowSx}>
            <SampleIcon style={{ marginRight: "4px" }} /> {t("samples")}
          </div>
        );
        break;
      case "/sample-shipments":
        title = (
          <div style={rowSx}>
            <SampleIcon style={{ marginRight: "4px" }} />{" "}
            {t("sampleOrders", "Sample Orders")}
          </div>
        );
        break;
      case "/sample-shipments/new":
        title = (
          <div style={rowSx}>
            <SampleIcon style={{ marginRight: "4px" }} />{" "}
            {t("createSampleShipment")}
          </div>
        );
        break;
      case "/sample-shipments/confirm":
        title = (
          <div style={rowSx}>
            <SampleIcon style={{ marginRight: "4px" }} />{" "}
            {t("confirmSampleShipment")}
          </div>
        );
        break;
      case "/sample-shipments/summary":
        title = (
          <div style={rowSx}>
            <SampleIcon style={{ marginRight: "4px" }} />{" "}
            {t("sampleShipmentDetail")}
          </div>
        );
        break;
      case "/sample/setup":
        title = (
          <div style={rowSx}>
            <SettingsIcon key="icon" style={{ marginRight: "8px" }} />{" "}
            {t("settings", "Settings")}{" "}
          </div>
        );
        break;
      case "/analysis":
        title = [
          <FontAwesomeIcon
            key="icon"
            icon={faFlaskVial}
            style={{ marginRight: "4px" }}
          />,
          ` ${t("analyses")}`,
        ];
        break;
      case "/analytic":
        title = (
          <div style={rowSx}>
            <AnalyticsIcon key="icon" style={{ marginRight: "8px" }} />
            {t("analytics")}
          </div>
        );
        break;
      case "/exports":
        title = [
          <FontAwesomeIcon
            key="icon"
            icon={faFlaskVial}
            style={{ marginRight: "4px" }}
          />,
          ` ${t("exports")}`,
        ];
        break;
      case "/profile":
        title = (
          <div style={rowSx}>
            <UsersIcon key="icon" style={{ marginRight: "8px" }} />
            {t("myProfile")}
          </div>
        );
        break;
      default:
        title = t("analyses");
    }
  }

  // If a center is selected, display studyCode + centerNumber + title
  if (centerNumber) {
    title = (
      <div style={rowSx}>
        {studyCode && (
          <>
            <StudyIcon
              key="studyIcon"
              style={{ marginRight: "8px", ...clickableSx }}
              onClick={() => navigateTo(studyTarget)}
            />
            <span
              key="studyCode"
              style={{ ...clickableSx }}
              onClick={() => navigateTo(studyTarget)}>
              {studyCode}
            </span>
            <span key="studySeparator" style={separatorSx}>
              {">"}
            </span>
          </>
        )}
        <CentersIcon
          key="centerIcon"
          style={{ marginRight: "4px", ...clickableSx }}
          onClick={() => navigateTo(centerTarget)}
        />
        <span
          key="centerNumber"
          style={{ ...clickableSx }}
          onClick={() => navigateTo(centerTarget)}>
          {" "}
          {`${t("center")} ${centerNumber} `}
        </span>
        <span key="centerSeparator" style={separatorSx}>
          {">"}
        </span>
        {showOrderCrumb && (
          <>
            <ShoppingCartIcon
              key="orderIcon"
              style={{ marginRight: "4px", ...clickableSx }}
              onClick={() => navigateTo(orderTarget)}
            />
            <span
              key="orderNumber"
              style={{ ...clickableSx }}
              onClick={() => navigateTo(orderTarget)}>
              {` Order ${orderNumber} `}
            </span>
            <span key="orderSeparator" style={separatorSx}>
              {">"}
            </span>
          </>
        )}
        {title}
      </div>
    );
  }
  // If only a study is selected, display studyCode + title
  else if (studyCode) {
    title = (
      <div style={rowSx}>
        <StudyIcon
          key="studyIcon"
          style={{ marginRight: "8px", ...clickableSx }}
          onClick={() => navigateTo(studyTarget)}
        />
        <span
          key="studyCode"
          style={{ ...clickableSx }}
          onClick={() => navigateTo(studyTarget)}>{` ${studyCode} `}</span>
        <span key="studySeparatorOnly" style={separatorSx}>
          {">"}
        </span>
        {title}
      </div>
    );
  }
  return title;
};

export default renderTitle;
